export const SECONDS_IN_A_MINUTE = 60;
export const SECONDS_IN_AN_HOUR = 3600;
export const SECONDS_IN_A_DAY = 86400;
export const SECONDS_IN_A_MONTH = SECONDS_IN_A_DAY * 30;
export const SECONDS_IN_A_YEAR = SECONDS_IN_A_MONTH * 12;

export const MILLISECONDS_IN_A_MINUTE = 60000;
export const MILLISECONDS_IN_AN_HOUR = 60 * MILLISECONDS_IN_A_MINUTE;
export const MILLISECONDS_IN_A_DAY = 24 * MILLISECONDS_IN_AN_HOUR;
export const MILLISECONDS_IN_A_MONTH = 30 * MILLISECONDS_IN_A_DAY;
export const MILLISECONDS_IN_A_YEAR = 12 * MILLISECONDS_IN_A_MONTH;

export const SECONDS_REPRESENTATION = 's';
export const MINUTES_REPRESENTATION = 'm';
export const HOURS_REPRESENTATION = 'h';
export const DAY_REPRESENTATION = 'd';
export const MONTH_REPRESENTATION = 'mo';
export const YEAR_REPRESENTATION = 'y';
